import React from 'react';
import { mediabarBlogPropTypes } from './MediabarBlogPropTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import Picture from '@Theme/hijunior/components/Picture/Picture';
import * as styles from './MediabarBlog.module.scss';
const MediabarBlog = ({
  items,
  href,
  title,
  heading,
  classname
}) => {
  if (!items && !heading) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles.root} ${classname || ''}`
  }, heading && /*#__PURE__*/React.createElement("div", {
    className: styles.rootHeading
  }, heading), items && /*#__PURE__*/React.createElement("div", {
    className: styles.rootItemsWrapper
  }, /*#__PURE__*/React.createElement("a", {
    href: href,
    title: title,
    className: styles.rootItems
  }, items.map(({
    icon,
    picture
  }, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: styles.rootIconWrapper
  }, (icon === null || icon === void 0 ? void 0 : icon.path) && /*#__PURE__*/React.createElement(Icon, {
    path: icon === null || icon === void 0 ? void 0 : icon.path,
    viewBox: icon === null || icon === void 0 ? void 0 : icon.viewBox,
    classname: styles.rootIcon
  }), (picture === null || picture === void 0 ? void 0 : picture.src) && /*#__PURE__*/React.createElement(Picture, {
    xs: {
      src: picture.src
    },
    alt: picture.alt,
    pictureClassname: styles.rootPicture,
    imgClassname: styles.rootImage
  }))))));
};
export default MediabarBlog;